import { render, staticRenderFns } from "./ruleAdd.vue?vue&type=template&id=2888e4c0&scoped=true&"
import script from "./ruleAdd.vue?vue&type=script&lang=js&"
export * from "./ruleAdd.vue?vue&type=script&lang=js&"
import style0 from "./ruleAdd.vue?vue&type=style&index=0&id=2888e4c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888e4c0",
  null
  
)

export default component.exports